'use client';

import { createLazyComponent } from './LazyLoad';

/**
 * Lazy-loaded Chart component wrapper
 *
 * Performance optimization: Recharts library (~150-200KB) is only loaded
 * when chart components are actually rendered, reducing initial bundle size.
 *
 * Usage: Import this instead of the regular Chart components in pages that
 * don't immediately need charts (e.g., behind tabs, conditional rendering).
 */

export const ChartContainer = createLazyComponent(
  () =>
    import('./Chart').then((mod) => ({
      default: mod.ChartContainer as never,
    })) as never,
  'section'
);

export const ChartTooltip = createLazyComponent(
  () =>
    import('./Chart').then((mod) => ({
      default: mod.ChartTooltip as never,
    })) as never,
  'inline'
);

export const ChartTooltipContent = createLazyComponent(
  () =>
    import('./Chart').then((mod) => ({
      default: mod.ChartTooltipContent as never,
    })) as never,
  'inline'
);

export const ChartLegend = createLazyComponent(
  () =>
    import('./Chart').then((mod) => ({
      default: mod.ChartLegend as never,
    })) as never,
  'inline'
);

export const ChartLegendContent = createLazyComponent(
  () =>
    import('./Chart').then((mod) => ({
      default: mod.ChartLegendContent as never,
    })) as never,
  'inline'
);

// Re-export types from the original Chart module
export type { ChartConfig, ChartContainerProps, ChartLegendContentProps, ChartTooltipContentProps } from './Chart';
